import { orderBy } from 'lodash'
import { formatNumber } from '@/lib/utils'

const mapperQuadrants = (quadrants, visualizationType) => {
    let mappedUsers = []
    const matrix = quadrants.reduce((object, quadrant) => {
        const { info, users, x_axis, y_axis } = quadrant

        const quadrantMappedUsers = mapperUsers(
            users,
            quadrant,
            visualizationType
        )
        mappedUsers = mappedUsers.concat(quadrantMappedUsers)

        return {
            ...object,
            [y_axis]: {
                ...object[y_axis],
                [x_axis]: {
                    ...quadrant,
                    info: {
                        ...info,
                        users_percent: formatNumber(info.users_percent),
                    },
                    users: quadrantMappedUsers,
                },
            },
        }
    }, {})

    return {
        matrix,
        users: mappedUsers,
    }
}

const mapperUsers = (users, quadrant, visualizationType) => {
    const mappedUsers = getMappedUsers(users, quadrant, visualizationType)
    return orderUsers(mappedUsers, visualizationType)
}

const getMappedUsers = (users, quadrant, visualizationType) => {
    return users.map(user => {
        const { scores } = user
        const result = {
            ...user,
            quadrant: {
                id: quadrant.id,
                title: quadrant.title,
                x_axis: quadrant.x_axis,
                y_axis: quadrant.y_axis,
            },
            calibrated: {
                x: null,
                y: null,
            },
            calculated: {
                x: formatNumber(scores.calculated.x),
                y: formatNumber(scores.calculated.y),
            },
            hasCalibration: scores.calibrated !== null,
        }

        if (scores.calibrated !== null && visualizationType == 'calibrated') {
            result.x = scores.calibrated.x
            result.y = scores.calibrated.y
        } else {
            result.x = scores.calculated.x
            result.y = scores.calculated.y
        }

        if (scores.calibrated) {
            result.calibrated.x = formatNumber(scores.calibrated.x)
            result.calibrated.y = formatNumber(scores.calibrated.y)
        }

        return result
    })
}

const orderUsers = users => {
    const sort = ['desc', 'desc', 'asc']
    const orderFields = ['x', 'y', 'name']
    return orderBy(users, orderFields, sort)
}

export default mapperQuadrants
